import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LeadFilters } from '../components/leads/LeadFilters';
import { LeadsTable } from '../components/leads/LeadsTable';
import { NewLeadModal, NewLeadFormData } from '../components/leads/NewLeadModal';
import { useDataStore } from '../context/DataStoreContext';
import { Plus, Users } from 'lucide-react';
export function LeadsList() {
  const {
    leads,
    createLead
  } = useDataStore();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Keyboard shortcut: "N" opens new lead modal
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.key === 'n' || e.key === 'N') && !isModalOpen && document.activeElement?.tagName !== 'INPUT' && document.activeElement?.tagName !== 'TEXTAREA') {
        e.preventDefault();
        setIsModalOpen(true);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isModalOpen]);
  const handleCreate = (form: NewLeadFormData) => {
    let computedState: 'Nuevo' | 'Micro-acuerdo' | 'LeadCualificado' = 'Nuevo';
    if (form.CUALIFICADO) {
      computedState = 'LeadCualificado';
    } else if (form.MICRO_ACUERDO_PAGADO) {
      computedState = 'Micro-acuerdo';
    }
    const newLead = createLead({
      NOMBRE_NEGOCIO: form.NOMBRE_NEGOCIO.trim(),
      DECISOR_NOMBRE: form.DECISOR_NOMBRE.trim(),
      DECISOR_CARGO: form.DECISOR_CARGO.trim(),
      TELEFONO_WHATSAPP: form.TELEFONO_WHATSAPP.trim(),
      DIRECCION: {
        calle: form.calle.trim(),
        numero: form.numero.trim(),
        barrio: form.barrio.trim(),
        ciudad: form.ciudad.trim()
      },
      TAG_GEO: form.TAG_GEO.trim(),
      LEAD_SOURCE: form.LEAD_SOURCE,
      ENLACE_GMB: form.ENLACE_GMB.trim() || undefined,
      RRSS_HANDLES: {
        instagram: form.instagram.trim() || undefined,
        facebook: form.facebook.trim() || undefined
      },
      NOTA_CARENCIA: form.NOTA_CARENCIA.trim(),
      VERIFICADO: form.VERIFICADO,
      STATE: computedState
    });
    navigate(`/app/leads/${newLead.id}`);
  };
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-997">
      {/* Page header — no CTA here; the only "Nuevo Lead" entry point lives in LeadFilters (with N shortcut) */}
      <div data-id="element-998">
        <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-growthly-muted mb-2" data-id="element-999">
          <Users size={14} className="text-growthly-muted" data-id="element-1000" />
          <span data-id="element-1001">Pipeline</span>
        </div>
        <h1 className="text-[32px] md:text-[36px] font-bold text-white leading-tight" data-id="element-1002">
          Leads
        </h1>
        <p className="text-[14px] text-growthly-muted mt-1.5" data-id="element-1003">
          Gestiona y cualifica tus prospectos. Pulsa{' '}
          <kbd className="inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5 mx-0.5 rounded border border-white/15 bg-white/[0.04] text-[11px] font-medium text-growthly-text" data-id="element-1004">
            N
          </kbd>{' '}
          para añadir un nuevo lead.
        </p>
      </div>

      {leads.length === 0 ? <div className="flex flex-col items-center justify-center py-20 px-4 border border-dashed border-white/10 rounded-2xl bg-gradient-to-br from-white/[0.03] to-white/[0.01]" data-id="element-1005">
          <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4 border border-white/5" data-id="element-1006">
            <Plus size={24} className="text-growthly-muted" data-id="element-1007" />
          </div>
          <h3 className="text-[18px] font-semibold text-white mb-2" data-id="element-1008">
            No hay leads todavía
          </h3>
          <p className="text-[14px] text-growthly-muted text-center max-w-md mb-6" data-id="element-1009">
            El CRM está completamente vacío. Empieza añadiendo tu primer lead
            para ver cómo se actualizan tus métricas y el dashboard.
          </p>
          <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center gap-2 bg-white text-[#0B0B0B] px-6 py-2.5 rounded-lg text-[14px] font-semibold hover:bg-white/90 transition-colors shadow-lg shadow-black/20" data-id="element-1010">
            <Plus size={16} data-id="element-1011" />
            Crear primer lead
          </button>
        </div> : <>
          <LeadFilters onNew={() => setIsModalOpen(true)} data-id="element-1012" />
          <LeadsTable leads={leads} data-id="element-1013" />
        </>}

      <NewLeadModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onCreate={handleCreate} data-id="element-1014" />
    </div>;
}